/* Toast */
import Vue from 'vue'
import Template from '@/components/toast/Toast.vue'

let timer = null;
const Toast = {
  install: function() {
    const toastConstructor =  Vue.extend(Template)
    let instance = new toastConstructor({}).$mount();
    document.body.appendChild(instance.$el);
    // 在Vue的原型链上注册方法，控制组件
    let toast = (msg, type, callback, duration, opacity, icon)=> {
      instance.visible = false;
      instance.message = '';
      if (timer) clearTimeout(timer);
      
      instance.type = type
      instance.message = msg
      instance.visible = true
      instance.opacity = opacity
      instance.icon = icon
      timer = setTimeout(() => {
        instance.visible = false;
        if (typeof callback === 'function') callback();
      }, duration)
    }
    let hide = ()=> {
      instance.visible = false;
      if (timer) clearTimeout(timer);
    }
    Vue.prototype.$toast = {
      show(msg, duration = 2000, callback, opacity = 0) {
        toast(msg, 1, callback, duration, opacity, '');
      },
      loading(msg = '', duration = 200000, callback, opacity = 0) {
        toast(msg, 5, callback, duration, opacity,'');
      },
      loadingIcon(msg = '', icon = '', duration = 200000, callback, opacity = 0) {
        toast(msg, 5, callback, duration, opacity, icon);
      },
      hide() {
        hide();
      }
    }
  }
}
export default Toast
